export default "__VITE_ASSET__CbSMR8zu__"